if (document.getElementById('enquirySelector')) {
    const enquirySelector = new Vue({
        el: '#enquirySelector',
        data: () => ({
            querySelector: '',
            showAllQueries: false,
            allQueries: ''
        }),
        methods: {
            urlChange(queryString) {
                if (queryString) {
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + queryString;
                } else {
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                }
                window.history.pushState({ path: newurl }, '', newurl);
            },
            next() {        
                if (this.querySelector == 'technical' && this.showAllQueries == false) {
                    return window.location.href ="/help-and-support/raise-a-new-support-request/nature-of-technical-query"
                } else
                    if (this.querySelector == 'other' && this.showAllQueries == false) {
                        this.showAllQueries = true;
                        this.urlChange('?query-type=other') 
                    }
                else {
                        return window.location.href=this.allQueries
                }
            },
            back() {
                this.showAllQueries = false;
                this.querySelector = '';
                this.allQueries = '';
                this.urlChange();
            }
        },
        mounted() {
            var self = this;
            this.showAllQueries = false;
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('query-type') == 'other') {
                this.showAllQueries = true;
                this.querySelector = 'other';
            }
            window.onpopstate = function (event) {
                const url = window.location.href.split("?")[0];
                if (url == window.location.href || event.state == null || (event.state.path && !event.state.path.indexOf('query-type') >= 0)) {
                    console.log(event)
                    window.history.replaceState(null, document.title, url);
                    self.showAllQueries = false;
                    self.querySelector = "";
                }
            };
        },
    })
}
